import { getLabelMessage } from '@gef-ui/localization/messages';
import Xmark from '@gef-ui/material-icons/Xmark';
import { sxPropType } from '@gef-ui/material/components/utils';
import useIsTabletAndUp from '@gef-ui/material/hooks/useIsTabletAndUp';
import MuiAlert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { useDefaultComponentValue } from '../../utils';
import { CopyButton } from '../ActionButtons';
const copyButtonStyle = {
    height: 'fit-content',
    backgroundColor: 'inherit',
    boxShadow: 'none',
    color: (theme)=>theme.palette.error.shades['160p']
};
const Alert = styled(MuiAlert)({
    '& .MuiAlert-action': {
        marginRight: 0,
        paddingTop: 0
    }
});
const COMPONENT_NAME = 'MuiErrorAlert';
const ErrorAlert = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { isError, timestamp, onClose, sx, ...other } = props;
    const isTabletAndUp = useIsTabletAndUp();
    return /*#__PURE__*/ React.createElement(Alert, {
        sx: sx,
        severity: isError ? 'error' : 'success',
        action: isError && /*#__PURE__*/ React.createElement(Stack, {
            direction: "row",
            sx: {
                alignItems: 'center'
            }
        }, /*#__PURE__*/ React.createElement(CopyButton, {
            sx: {
                ...copyButtonStyle,
                '&:hover': {
                    ...copyButtonStyle
                }
            },
            noIcon: true,
            timestamp: timestamp,
            ...other
        }, getLabelMessage('errors:copyError')), /*#__PURE__*/ React.createElement(IconButton, {
            onClick: onClose,
            sx: copyButtonStyle
        }, /*#__PURE__*/ React.createElement(Xmark, null)))
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: isTabletAndUp ? 'row' : 'column',
        sx: {
            flexGrow: 1,
            justifyContent: 'space-between',
            textAlign: 'center'
        }
    }, /*#__PURE__*/ React.createElement("div", null, isError ? `${getLabelMessage('common:error').toUpperCase()}: ${getLabelMessage('errors:errorNotSent')}` : getLabelMessage('errors:errorSent'))));
};
ErrorAlert.propTypes = {
    isError: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    sx: sxPropType,
    timestamp: PropTypes.string
};
export default ErrorAlert;
